module.exports = __webpack_public_path__ + "img/03_fgw.c9ab8b09.jpg";